import { defaultAxios } from "../../utils/api/axios";
import { importUrl } from "../../utils/constance";

export const getAxiosImportServer = async (url, params) => {
  const BASE_URL =
    import.meta.env.MODE === "production"
      ? "https://officeapi.staginserver.xyz/api"
      : "http://51.159.0.19:8001/api";
  try {
    const config = {
      // baseURL: importUrl,
      baseURL: BASE_URL,
      url,
      method: "get",
      params,
    };

    const data = await defaultAxios(config);

    if (data) {
      return data;
    } else {
      return false;
    }
  } catch (error) {
    console.error("getAxiosImportServer here", error);
    return false;
  }
};
